import { useNavigate } from "@remix-run/react";
import { XCircleIcon } from "@heroicons/react/24/outline";

import { Popover } from "@headlessui/react";
import MediaIcon from "~/assets/icons/icon-media.svg";
import Meeting from "~/assets/icons/icon-event.svg";
import Book from "~/assets/icons/icon-fachbeitraege.svg";
import MethodenIcon from "~/assets/icons/icon-methoden.svg";

import LearnPlatformLogo from "~/assets/images/logomain.png";

import type { LinksData } from "~/api/get_static_data.server";
import { ThemenBox } from "~/components";
import { themenCards } from "~/constants/themen_cards";

const mediaLinks = [
  {
    name: "Medien",
    description:
      "Entdecke eine Fülle an Unterrichtsmedien - von inspirierenden Impulsen bis hin zu umfangreichen Unterrichtsreihen.",
    href: "/search/main",
    src: MediaIcon,
    disabled: false,
  },
  {
    name: "Veranstaltungen",
    description:
      "Du suchst eine Fortbildung? Hier erhältst du eine aktuelle Übersicht vieler Angebote vor Ort und digital.",
    href: "https://veranstaltungen.ru-digital.de",
    src: Meeting,
    disabled: false,
  },
  {
    name: "Fachbeiträge",
    description:
      "Mehr wissen: Finde Antworten auf Fragen zu vielfältigen Themen und erweitere deine Fachkenntnisse.",
    href: "/professional_article/main",
    src: Book,
    disabled: false,
  },
  {
    name: "Methoden",
    description:
      "Entdecke Unterrichtsmethoden - praxisnah, fundiert und für alle Schulstufen geeignet!.",
    href: "https://explore.ru-digital.de/methoden/",
    src: MethodenIcon,
    disabled: false,
  },
];
// const themen = [
//   // {
//   //   name: "Schulpastoral",
//   //   href: "#",
//   //   src: user.imageUrl,
//   //   description:
//   //     "Get a better understanding of where your traffic is coming from.",
//   // },
//   {
//     name: "Inklusion",
//     href: "/inklusion",
//     src: inklusionImage,
//     description:
//       "Öffne Türen für die Vielfalt:  Entdecke neue Perspektiven, Methoden und Materialien.",
//   },
//   {
//     name: "Themenschwerpunkte",
//     href: "/themenschwerpunkte",
//     src: themenschwerpunkteImage,
//     description: "Für Dich zusammengestellt: handverlesene Medienportfolios.",
//   },
//   {
//     name: "Methodenglossar",
//     href: "https://methoden.ru-digital.de",
//     src: methodGlossarImg,
//     description:
//       "Lust auf Neues: Entdecke eine Vielfalt an elementaren Methoden.",
//   },
// ];

export const NavigationFlyoutMenu = ({
  links,
}: {
  links: Array<LinksData>;
}) => {
  const navigate = useNavigate();

  return (
    <div className="section-wrapper relative w-full pb-3 pt-5 md:flex md:flex-nowrap md:items-start md:justify-between md:gap-8 md:px-0 xl:gap-12">
      <div className="w-full min-w-0 md:shrink md:grow md:basis-3/5">
        <div className="relative grid  gap-2  sm:grid-cols-2 sm:gap-4">
          {mediaLinks.map((item) => (
            <Popover.Panel key={item.name}>
              {({ close }) => {
                const isExternal = /^https?:|^mailto:|^tel:/i.test(item.href);
                if (!isExternal) {
                  return (
                    <button
                      onClick={() => {
                        navigate(item.href);
                        close();
                      }}
                      key={item.name}
                      disabled={item.disabled}
                      className="flex h-24 items-start justify-center rounded-lg bg-gray-100 p-3 hover:bg-gray-200 disabled:opacity-50"
                    >
                      <div className="flex h-[46px] w-[46px] flex-shrink-0 items-center justify-center rounded-full  bg-[#ffb503] sm:h-12 sm:w-12">
                        <div
                          className="h-6 w-6 bg-black"
                          aria-hidden="true"
                          style={{
                            WebkitMaskImage: `url(${item.src})`,
                            maskImage: `url(${item.src})`,
                            WebkitMaskRepeat: "no-repeat",
                            maskRepeat: "no-repeat",
                            WebkitMaskPosition: "center",
                            maskPosition: "center",
                            WebkitMaskSize: "contain",
                            maskSize: "contain",
                          }}
                        />
                      </div>
                      <div className="ml-4 text-left">
                        <p className="text-sm font-bold text-primary lg:text-base">
                          {item.name}
                        </p>
                        <p className="mt-1 text-xs text-textColor-navigation">
                          {item.description}
                        </p>
                      </div>
                    </button>
                  );
                } else {
                  return (
                    <a
                      key={item.name}
                      href={item.href}
                      target="_blank"
                      rel="noreferrer"
                      className="flex h-24 items-start justify-center rounded-lg bg-gray-100 p-3 hover:bg-gray-200 disabled:opacity-50"
                    >
                      <div className="flex h-[46px] w-[46px] flex-shrink-0 items-center justify-center rounded-full  bg-[#ffb503] sm:h-12 sm:w-12">
                        <div
                          className="h-6 w-6 bg-black"
                          aria-hidden="true"
                          style={{
                            WebkitMaskImage: `url(${item.src})`,
                            maskImage: `url(${item.src})`,
                            WebkitMaskRepeat: "no-repeat",
                            maskRepeat: "no-repeat",
                            WebkitMaskPosition: "center",
                            maskPosition: "center",
                            WebkitMaskSize: "contain",
                            maskSize: "contain",
                          }}
                        />
                      </div>
                      <div className="ml-4 text-left">
                        <p className="text-sm font-bold text-primary lg:text-base">
                          {item.name}
                        </p>
                        <p className="mt-1 text-xs text-textColor-navigation">
                          {item.description}
                        </p>
                      </div>
                    </a>
                  );
                }
              }}
            </Popover.Panel>
          ))}
        </div>
        <div className="relative mt-6 grid gap-1 sm:gap-2 md:grid-cols-5 lg:grid-cols-4">
          {links.length &&
            links.map((item) => (
              <Popover.Panel key={item.name}>
                {({ close }) => {
                  if (item.isInternal) {
                    return (
                      <button
                        onClick={() => {
                          navigate(item.href);
                          close();
                        }}
                        key={item.name}
                        className="flex items-start rounded-lg py-1 hover:bg-gray-50"
                      >
                        <div>
                          <p className="text-sm font-bold text-primary">
                            {item.name}
                          </p>
                        </div>
                      </button>
                    );
                  }
                  return (
                    <a
                      key={item.name}
                      href={item.href}
                      target="_blank"
                      rel="noreferrer"
                      className="flex items-start rounded-lg py-1 hover:bg-gray-50"
                    >
                      <div>
                        <p className="text-sm font-bold text-primary">
                          {item.name}
                        </p>
                      </div>
                    </a>
                  );
                }}
              </Popover.Panel>
            ))}
        </div>
      </div>
      <div className="hidden md:flex md:shrink-0 md:basis-2/5 md:justify-end">
        <div className="flex w-full max-w-[360px] flex-col gap-4 xl:max-w-[430px] 2xl:max-w-[460px]">
          {themenCards.slice(0, 2).map((item) => (
            <ThemenBox
              key={item.title}
              title={item.title}
              description={item.description}
              to={item.to}
              variant="flyout"
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export const NavigationFlyoutMobileMenu = ({
  links,
  close,
}: {
  links: Array<LinksData>;
  close: () => void;
}) => {
  const navigate = useNavigate();
  return (
    <div className="max-h-[80vh] divide-y-2 divide-gray-50 overflow-auto rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
      <div className="px-5 pt-5 pb-6 sm:pb-8">
        <div className="flex items-center justify-between">
          <div>
            <img
              className="h-8 w-auto"
              src={LearnPlatformLogo}
              alt="LearnPlatformLogo"
            />
          </div>
          <div className="-mr-2">
            <Popover.Button className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-inset focus:ring-orange-500">
              <span className="sr-only">Close menu</span>
              <XCircleIcon className="h-6 w-6" aria-hidden="true" />
            </Popover.Button>
          </div>
        </div>
        <div className="mt-4">
          <nav>
            <div className="grid gap-2 sm:grid-cols-2 sm:gap-y-8 sm:gap-x-2">
              {mediaLinks.map((item) => (
                <Popover.Panel key={item.name}>
                  {({ close }) => {
                    const isExtern = /^https?:|^mailto:|^tel:/i.test(item.href);
                    if (!isExtern) {
                      return (
                        <button
                          onClick={() => {
                            navigate(item.href);
                            close();
                          }}
                          key={item.name}
                          disabled={item.disabled}
                          className="-m-3 flex items-start rounded-lg p-3 hover:bg-gray-50 disabled:opacity-50"
                        >
                          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full  bg-[#ffb503] sm:h-12 sm:w-12">
                            <div
                              className="h-5 w-5 bg-black"
                              aria-hidden="true"
                              style={{
                                WebkitMaskImage: `url(${item.src})`,
                                maskImage: `url(${item.src})`,
                                WebkitMaskRepeat: "no-repeat",
                                maskRepeat: "no-repeat",
                                WebkitMaskPosition: "center",
                                maskPosition: "center",
                                WebkitMaskSize: "contain",
                                maskSize: "contain",
                              }}
                            />
                          </div>
                          <div className="ml-4 text-left">
                            <p className="text-base font-medium text-primary">
                              {item.name}
                            </p>
                            <p className="mt-1 text-sm text-textColor-navigation 2xl:w-52">
                              {item.description}
                            </p>
                          </div>
                        </button>
                      );
                    } else {
                      return (
                        <a
                          href={item.href}
                          target="_blank"
                          rel="noreferrer"
                          key={item.name}
                          className="-m-3 flex items-start rounded-lg p-3 hover:bg-gray-50 disabled:opacity-50"
                        >
                          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full  bg-[#ffb503] sm:h-12 sm:w-12">
                            <div
                              className="h-5 w-5 bg-black"
                              aria-hidden="true"
                              style={{
                                WebkitMaskImage: `url(${item.src})`,
                                maskImage: `url(${item.src})`,
                                WebkitMaskRepeat: "no-repeat",
                                maskRepeat: "no-repeat",
                                WebkitMaskPosition: "center",
                                maskPosition: "center",
                                WebkitMaskSize: "contain",
                                maskSize: "contain",
                              }}
                            />
                          </div>
                          <div className="ml-4 text-left">
                            <p className="text-base font-medium text-primary">
                              {item.name}
                            </p>
                            <p className="mt-1 text-sm text-textColor-navigation 2xl:w-52">
                              {item.description}
                            </p>
                          </div>
                        </a>
                      );
                    }
                  }}
                </Popover.Panel>
              ))}
            </div>

            {/* <div className="mt-4 grid gap-2 sm:grid-cols-2 sm:gap-y-8 sm:gap-x-2">
              {themen.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="-m-3 flex items-center rounded-lg p-3 hover:bg-gray-50"
                >
                  <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-secondary text-white">
                    <img
                      className="h-10 w-10  rounded-md object-cover"
                      src={item.src}
                      alt=""
                    />
                  </div>
                  <div className="ml-1 text-left">
                    <p className="ml-2 text-base font-medium text-primary">
                      {item.name}
                    </p>
                  </div>
                </a>
              ))}
            </div> */}
          </nav>
        </div>
      </div>
      <div className="py-6 px-5">
        <div className="grid grid-cols-1 gap-4 pb-3">
          {links.length &&
            links.map((item) => {
              if (item.isInternal) {
                return (
                  <button
                    onClick={() => {
                      navigate(item.href);
                      close();
                    }}
                    key={item.name}
                    className="flex items-start rounded-lg py-2 hover:bg-gray-50"
                  >
                    <div>
                      <p className="text-sm font-bold text-primary">
                        {item.name}
                      </p>
                    </div>
                  </button>
                );
              }
              return (
                <a
                  key={item.name}
                  href={item.href}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-start rounded-lg py-2 hover:bg-gray-50"
                >
                  <div>
                    <p className="text-sm font-bold text-primary">
                      {item.name}
                    </p>
                  </div>
                </a>
              );
            })}
        </div>
      </div>
    </div>
  );
};
